import { render, staticRenderFns } from "./EditUpgradeBonusSetting.vue?vue&type=template&id=20ba95f0"
import script from "./EditUpgradeBonusSetting.vue?vue&type=script&lang=js"
export * from "./EditUpgradeBonusSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports